<template>
  <div>
    <div class="custom-address-list">
      <div
        v-for="item in list"
        :key="item.id"
        class="custom-address-item"
        @click="sele_address(item)"
      >
        <div class="address-content">
          <!-- 地址内容展示 -->
          <div class="address-detail">
            {{ item.address }}
          </div>
          
          <div class="name-tel">
            <span style="margin-right: 20px">{{ item.name }}</span>
            <span>{{ item.tel }}</span>
          </div>
        </div>

        <!-- 删除按钮 -->
        <div class="action-buttons">
          <van-button
            style="border: none; color: #de6262"
            size="small"
            @click.stop="handleDelete(item.id)"
          >
            删除
          </van-button>
        </div>
      </div>

      <!-- 添加地址按钮 -->
      <van-button block type="primary" @click="onAdd" class="add-button">
        新增地址
      </van-button>
    </div>
  </div>
</template>

<script>
import { address } from "@/utils/request";
import { del_address } from "@/utils/request";
export default {
  data() {
    return {
      chosenAddressId: "",
      list: [],
      entry: "",
    };
  },
  methods: {
    sele_address(item) {
      if (this.entry == "info") {
        this.chosenAddressId = item.id;
        localStorage.setItem("address", JSON.stringify(item));
        this.$router.back();
      }
    },
    onAdd() {
      this.$router.push("/add_address");
    },
    handleDelete(id) {
      this.$dialog
        .confirm({
          title: "删除地址",
          message: "确定删除这个地址吗？",
        })
        .then(async () => {
          this.list = this.list.filter((item) => item.id !== id);
          if (this.chosenAddressId === id) {
            this.chosenAddressId = this.list[0]?.id || "";
          }
          await del_address({
            data: {
              token: localStorage.getItem("auth_token"),
              id,
              type: 2,
            },
          });
          this.$toast.success("删除成功");
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  async mounted() {
    this.entry = this.$route.query.type ? this.$route.query.type : "";
    // 用户地址列表
    const res = await address({
      data: {
        token: localStorage.getItem("auth_token"),
      },
    });
    this.list = res.data.data.map((item) => ({
      id: item.id,
      name: item.receiver_name,
      tel: item.receiver_phone,
      // 关键修改：address必须是完整字符串
      address: `${item.province}${item.city}${item.district}${item.street}`,
      province: item.province,
      city: item.city,
      county: item.district,
      addressDetail: item.street,
      isDefault: item.isdefault === 1,
    }));

    const defaultItem = this.list.find((item) => item.isDefault === true);
    this.chosenAddressId = defaultItem ? defaultItem.id : "";
  },
};
</script>

<style scoped>
.custom-address-list {
  padding: 10px;
}

.custom-address-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.address-content {
  flex: 1;
}

.name-tel {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
}

.address-detail {
  color: #666;
  font-size: 15px;
  margin-bottom: 8px;
  text-align: left;
  font-weight: 700;
}

.default-tag {
  display: inline-block;
  padding: 2px 6px;
  background: #1989fa;
  color: white;
  border-radius: 4px;
  font-size: 12px;
}

.action-buttons {
  margin-left: 15px;
}

.add-button {
  margin-top: 20px;
  position: fixed;
  bottom: 6px;
  background: #fa4730;
  border: none;
  border-radius: 20px;
  width: 94%;
  margin: 0 auto;
}
</style>


